import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalScopeOverrideContext = /*#__PURE__*/createContext(undefined);
export const ApprovalScopeOverrideProvider = ({
  children,
  overrideScopes
}) => /*#__PURE__*/_jsx(ApprovalScopeOverrideContext.Provider, {
  value: overrideScopes,
  children: children
});